export default __webpack_public_path__ + "static/media/gluten.152a011e.png";